import { Navigate } from "react-router-dom";
import { getUserAgentDetails } from "../../components/App/userAgent";
import { getTenant } from "../../theme";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function AppRedirect() {
  const { t, i18n } = useTranslation("appRedirect");
  let navigateUrl = "/";
  const uaDetails = getUserAgentDetails();
  const tenant = getTenant();

  const mobileDevices = ["mobile", "tablet"];
  const android = uaDetails.os.name?.includes("Android");
  const ios = uaDetails.os.name === "iOS";
  const mobileDevice = mobileDevices.some((i) => i === uaDetails.device.type);

  if (mobileDevice) {
    if (android) {
      navigateUrl = tenant.android;
    }
    if (ios) {
      navigateUrl = tenant.ios;
    }
    window.location.href = navigateUrl;
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "text.primaryDefault",
          gap: "12px",
        }}
      >
        <Typography variant="h6" sx={{ color: "text.white", textAlign: "center" }}>
          {t("issuesDownloading")}
        </Typography>
        <Typography mb={8} variant="body1" sx={{ color: "text.white", textAlign: "center" }}>
          {t("downloadAppLinks")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              height: "60px",
              width: "200px",
              backgroundImage: "url(../../images/download-android.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              cursor: "pointer",
            }}
            onClick={() => window.open(tenant.android, "_blank")}
          ></Box>
          <Box
            sx={{
              height: "60px",
              width: "200px",
              backgroundImage: "url(../../images/download-ios.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              cursor: "pointer",
            }}
            onClick={() => window.open(tenant.ios, "_blank")}
          ></Box>
        </Box>
      </Box>
    );
  }
  return <Navigate to={navigateUrl} />;
}
